<div class="w-full rounded-lg border border-gray-200 bg-white px-4 py-3 text-sm">
  <div class="flex flex-row items-center justify-between gap-4">
    <span class="font-medium">
      myCheck-Serie: {{ doneCount }} von {{ rows.length }} erledigt
      @if (!series.confirmed) {
        <span class="font-normal text-gray-500">– Plan noch nicht bestätigt</span>
      }
    </span>
    @if (hasNextStep && !busy) {
      @if (paused) {
        <bic-button buttonType="white" (onClick)="resume.emit()">Fortsetzen</bic-button>
      } @else {
        <bic-button buttonType="white" (onClick)="pause.emit()">Anhalten</bic-button>
      }
    }
  </div>
  <ul class="mt-2 flex flex-col gap-1">
    @for (row of rows; track row.position) {
      <li class="flex flex-col">
        <div class="flex flex-row items-center gap-2">
          <fa-icon [icon]="row.icon" [class]="row.iconClass" [animation]="row.spin ? 'spin' : undefined"></fa-icon>
          @if (row.link) {
            <a [routerLink]="row.link" class="hover:underline">{{ row.name }}</a>
          } @else {
            <span>{{ row.name }}</span>
          }
          <span class="text-xs text-gray-500">{{ row.label }}</span>
        </div>
        @for (issue of row.issues; track $index) {
          <span class="ml-6 text-xs text-gray-600">– {{ issue }}</span>
        }
      </li>
    }
  </ul>
  @if (checkRunLink) {
    <a [routerLink]="checkRunLink" class="mt-2 inline-block font-medium text-[#009999] hover:underline">Prüflauf öffnen</a>
  }
</div>
